import SubPageShell from "@/components/SubPageShell";
import PortfolioSection from "@/components/PortfolioSection";

export default function PortfolioPage() {
  return (
    <SubPageShell testId="portfolio-page">
      {(config) => <PortfolioSection portfolio={config.portfolio || []} />}
    </SubPageShell>
  );
}
